<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="score-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="score-view">
                        <vuescroll>
                            <div class="score-head"></div>
                            <div class="score-table">
                                <table>
                                    <tr v-for="(item,index) in score_data" :key="index">
                                        <td style="width: 128px;">{{ index + 1 }}</td>
                                        <td style="width: 206px;">{{ item.chge_score }}</td>
                                        <td>{{ item.record_time }}</td>
                                    </tr>
                                </table>
                            </div>
                        </vuescroll>
                    </div>
                    <p class="notice">仅计入天命*荆州争霸地图中获取的军威值</p>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style scoped>
.score-modal{
    position: relative;
    width: 715px;
    height: 897px;
    font-size: 24px;
    color: #8e492e;
    background-image: url(~@/assets/images/bg-score.png);
}

.notice{
    color: #8e492e;
    text-align: center;
}

.title{
    width: 319px;
    height: 60px;
    margin: 15px auto 10px;
    background-image: url(~@/assets/images/title-score.png);  
}

.score-view{
    width: 656px;
    height: 670px;
    /* height: 455px; */
    margin: 0 auto 20px;
}

.score-view table{
    width: 100%;
}

.score-head{
    width: 636px;
    height: 51px;
    background-image: url(~@/assets/images/table-socre-head.png);      
}

.score-table tr{
    width: 636px;
    height: 68px;
    line-height: 68px;
    color: #8e492e;
    text-align: center;
    background: #f6e5c3;
}

</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            score_data : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){

        document.body.style.overflow = 'hidden';
        document.addEventListener('touchmove', this.stopTouch, this.opt); // 禁止页面滑动              

        this.render();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            document.body.style.overflow = ''; // 出现滚动条
            document.removeEventListener('touchmove', this.stopTouch, this.opt);     

            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        render (){
            this.$axios.get(ajax_url_map.queryscore,{})
            .then(
                res => {
                    this.score_data = res.data;
                },
                rej => {
                    this.$toast(rej.msg)
                }
            )
        },
        stopTouch(e){
            e.preventDefault();
        },                  
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/ScoreModal/scoreModal.vue